import React, { FC, ReactNode } from "react"
import styled from "styled-components"
import { Large, NotLarge, Medium, Small } from "../Responsive"
import { Spacer } from "../Atoms"

type TwoColumnRightPrimaryProps = {
  secondaryContent: ReactNode
  primaryContent: ReactNode
  bottomContent?: ReactNode
}

const FlexWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

const SecondaryDiv = styled.div`
  @media screen and (min-width: 960px) {
    display: block;
    width: calc(100% / 3);
    max-width: 320px;
    min-width: 232px;
  }
  @media screen and (max-width: 959px) {
    display: none;
  }
`

const MainDiv = styled.div`
  @media screen and (min-width: 960px) {
    width: calc(100% / 1.5);
    max-width: 600px;
    min-width: 384px;
  }
  @media screen and (max-width: 959px) {
    width: 100%;
  }
`

const TwoColumnRightPrimary: FC<TwoColumnRightPrimaryProps> = ({
  secondaryContent,
  primaryContent,
  bottomContent = null
}) => {
  return (
    <>
      <FlexWrapper>
        {/* hide secondary content if smaller than 960 */}
        <SecondaryDiv>{secondaryContent}</SecondaryDiv>
        <Large>
          <Spacer width={3} />
        </Large>
        <MainDiv>
          <NotLarge>{secondaryContent}</NotLarge>
          <Medium>
            <Spacer height={3} />
          </Medium>
          <Small>
            <Spacer height={2} />
          </Small>
          {primaryContent}
        </MainDiv>
      </FlexWrapper>
      {bottomContent && (
        <>
          <Spacer height={3} expand />
          {bottomContent}
        </>
      )}
    </>
  )
}

export default TwoColumnRightPrimary
